module.exports = __webpack_public_path__ + "img/grace.88d66d72.jpg";